import React, { useState, useEffect } from 'react';
import './ChatIcon.css';

const ChatIcon = ({ onClick, isOpen }) => {
  const [showWelcomeTooltip, setShowWelcomeTooltip] = useState(false);

  useEffect(() => {
    // Show welcome tooltip after 2 seconds when page loads
    const timer = setTimeout(() => {
      setShowWelcomeTooltip(true);
    }, 2000);

    // Hide tooltip after 5 seconds
    const hideTimer = setTimeout(() => {
      setShowWelcomeTooltip(false);
    }, 7000);

    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  const handleClick = () => {
    setShowWelcomeTooltip(false); // Hide tooltip when clicked
    onClick(); // This will toggle the chat state
  };

  return (
    <div 
      className={`chat-icon ${isOpen ? 'chat-open' : ''} ${showWelcomeTooltip ? 'show-welcome-tooltip' : ''}`}
      onClick={handleClick}
      title={isOpen ? "Close chat" : "Chat with our AI Assistant"}
    >
      <div className="chat-icon-inner">
        <i className="fas fa-comments"></i>
      </div>
      <div className="chat-icon-pulse"></div>
      <div className="chat-icon-tooltip">
        <span>
          {isOpen 
            ? "Close chat" 
            : showWelcomeTooltip 
              ? "👋 Hi! I'm CARAI - Ask me anything about our AI solutions! 🚀" 
              : "Chat with CARAI"
          }
        </span>
      </div>
    </div>
  );
};

export default ChatIcon;
